const n = "_wrapper_uc4z5_1", _ = "_links_uc4z5_11", l = "_linkItem_uc4z5_29", s = "_link_uc4z5_11", t = {
  wrapper: n,
  links: _,
  linkItem: l,
  link: s
};
export {
  t as default,
  s as link,
  l as linkItem,
  _ as links,
  n as wrapper
};
